module.exports = __webpack_public_path__ + "static/img/ios.a5065de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ios.png
// module id = NiBH
// module chunks = 1